import ipc from '@/utils/ipc'

export default async function ({ app, $axios, store, redirect }) {
  let port

  if (process.env.platform === 'electron') {
    port = await ipc('getPort')

    store.commit('network/setPort', port)
  }

  await store.dispatch('config/getConfig')

  if (store.getters['utils/isShared']) {
    $axios.defaults.baseURL = `http://localhost:${port}`
  } else {
    $axios.defaults.baseURL = store.getters['network/onLine']
      ? process.env.baseUrl
      : `http://localhost:${port}`
  }

  $axios.onRequest((req) => {
    if (req.method === 'post') {
      if (!req.data) {
        req.data = {}
      }

      const timezone = new Date().toString().split('GMT')[1].slice(0, 5)

      req.data.meta = {
        timezone: `${timezone.substr(0, 3)}:${timezone.substr(3, 2)}`,
        language: app.i18n.localeProperties.iso,
      }
    }
  })

  $axios.onRequest((config) => {
    if (config.useOverlay) store.commit('ui/start')
    return config
  })

  $axios.onResponse((response) => {
    if (response.config && response.config.useOverlay) {
      store.commit('ui/finish')
    }
    return response
  })

  if (app.router) {
    app.router.beforeEach((to, from, next) => {
      store.commit('ui/reset')
      next()
    })
  }

  $axios.onError((error) => {
    if (error.config && error.config.useOverlay) {
      store.commit('ui/finish')
    }
    const code = parseInt(error.response && error.response.status)

    if (code === 500) {
      const errorName = error.response.data.name
      switch (errorName) {
        case 'AdminUserRequiredError':
        case 'DbPathRequiredError':
          redirect(app.localePath('/config'))
          break
        case 'ContractAcceptanceRequiredError':
          redirect(app.localePath('/accept-contract'))
          break
        case 'LicenseRequiredError':
        case 'InvalidLicenseError':
          redirect(app.localePath('/settings/licenses'))
          break
      }
    }
  })

  // onError cannot suppress errors (it always re-throws internally). A direct
  // interceptor handles 401: it clears the session synchronously then does a
  // hard reload so the app boots fresh and auth middleware redirects to /login.
  // This avoids both the Nuxt error page and the infinite-loader caused by a
  // never-resolving promise.
  $axios.interceptors.response.use(null, (error) => {
    const code = parseInt(error.response && error.response.status)
    if (code === 401) {
      store.commit('user/logout')
      window.location.reload()
      return new Promise(() => {})
    }
    return Promise.reject(error)
  })
}
